import { render, staticRenderFns } from "./publish-approve-all-button.vue?vue&type=template&id=1afd6103"
import script from "./publish-approve-all-button.vue?vue&type=script&lang=js"
export * from "./publish-approve-all-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports